import { createApp } from 'vue'
import GameSearch from '../../components/search/game-search.vue'

document.addEventListener('DOMContentLoaded', () => {
  const app = createApp( GameSearch )
  app.mount('#game-search')
})